<template>
    <div class="hello" style="background-color:#f4f5f5; height:100%">
    <van-nav-bar :title="title" left-arrow @click-left="gotohome" />
        <div style="text-align:center; max-width:640px; height:auto; margin: 0 auto; padding: 0 auto; padding-top: 10px; ">
            <div>
                <span  style="color: #606266; font-size:15px;font-weight: 900;">小泉士多 KOIZUMISHOP</span>
            </div>
            <div style="margin-top:10px;">
                <van-image width="128px" height="128px" :src=pic fit="fill" round/>
            </div>
        </div>
        <div v-if="needReg" style="text-align:center; max-width:640px; height:300px; margin: 0 auto; padding: 0 auto; padding-top: 10px; ">
            <van-form @submit="onSubmit">
                <van-field
                    v-model="userData.name"
                    label="用戶姓名"
                    left-icon="user-o"
                    placeholder="請輸入用戶姓名"
                />
                <van-field
                    v-model="userData.email"
                    label="電郵地址"
                    left-icon="envelop-o"
                    placeholder="請輸入電郵地址"
                />
                <van-field
                    v-model="userData.phone"
                    label="電話號碼"
                    left-icon="phone-o"
                    placeholder="請輸入09開頭的電話號碼"
                />
                <van-field
                    v-model="userData.birthday"
                    label="出生日期"
                    left-icon="gift-o"
                    placeholder="點擊選擇您的生日"
                    readonly
                    @click="showDatePicker=true"
                />
                <van-popup class="date-pop" v-model="showDatePicker" position="bottom">
                    <van-datetime-picker
                        v-model="userData.birthday"
                        confirm-button-text="確認"
                        cancel-button-text="取消"
                        type="date"
                        title="選擇年月日"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="onConfirmDate"
                        @cancel="onCancelDate"
                    />
                </van-popup>
                <van-field
                    v-model="userData.id"
                    label="識別編號"
                    left-icon="warn-o"
                    readonly
                />
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">注冊會員</van-button>
                </div>
            </van-form>
        </div>
        <div style="margin:0 auto; text-align:center; padding-bottom:80px;">
          <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
            <div style="margin-top:20px;">
              <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
            </div>
        </div>
    </div>
</template>
<script>
import { getInfo, register, login, logout, getAccessToken } from '@/api/user'
import { setToken, setFBToken, setUser, getUser, getToken, removeToken, removeUser } from '@/utils/auth'
import { Notify, Toast } from 'vant'

export default {
  name: 'facebook',
  data () {
    return {
      needReg: false,
      title: '登入 / 注冊',
      showDatePicker: false,
      minDate: new Date(1940, 0, 1),
      maxDate: new Date(2005, 9, 1),
      pic: '/static/koizumishop.png',
      userData: {},
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        if (route.query.state) {
          var params = JSON.parse(route.query.state)
          this.redirect = params.redirect
          if (route.query.code) {
            getAccessToken({code: route.query.code, uri: params.uri}).then(res => {
              if (res.code === 200) {
                this.onSignInSuccess(res.data)
              } else {
                var uri = '/login'
                if (this.redirect) {
                  uri += '?redirect=' + this.redirect
                }
                this.$router.push({path: uri})
              }
            })
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    gotohome () {
      if (this.redirect) {
        this.$router.push({path: this.redirect})
      } else {
        this.$router.push('/')
      }
      window.scrollTo(0, 0)
    },
    onSignInSuccess (response) {
      getInfo({ token: response.access_token }).then(res => {
        if (res.code === 200) {
          this.pic = res.data.avatar
          this.userData = res.data
          if (res.data.register === '0') {
            this.needReg = true
          } else {
            // 登入
            login(this.userData).then(res => {
              if (res.code === 200) {
                Notify({ type: 'success', message: '登入成功' })
                Toast.success('歡迎回來')
                setToken(res.data.t)
                setFBToken(res.data.token)
                setUser(res.data.user)
                setTimeout(() => {
                  this.gotohome()
                }, 3000)
              } else {
                Notify({ type: 'danger', message: res.message })
                Toast.fail('登入失敗')
              }
            })
          }
        } else {
          Notify({ type: 'danger', message: res.message })
        }
      })
    },
    onSignInError (error) {
      console.log(error)
      this.pic = '/static/koizumishop.png'
      logout({ user: getUser(), token: getToken() }).then(res => {
        if (res.code === 200) {
          Notify({ type: 'success', message: '登出成功' })
          Toast.success('多謝惠顧')
          removeToken()
          removeUser()
          setTimeout(() => {
            this.gotohome()
          }, 3000)
        } else {
          Notify({ type: 'danger', message: res.message })
          Toast.fail('登出失敗')
        }
      })
    },
    onSubmit () {
      Toast.loading({
        message: '提交中...',
        forbidClick: true
      })
      // 注冊
      register(this.userData).then(res => {
        if (res.code === 200) {
          Notify({ type: 'success', message: '注冊會員成功' })
          Toast.success('注冊成功')
          setToken(res.data.t)
          setFBToken(res.data.token)
          setUser(res.data.user)
          window.fbq('track', 'CompleteRegistration')
          setTimeout(() => {
            this.gotohome()
          }, 3000)
        } else {
          Notify({ type: 'danger', message: res.message })
          Toast.fail('注冊失敗')
        }
      })
    },
    formatter (time) {
      let nowdata = time == null ? new Date() : new Date(time)
      let year = nowdata.getFullYear()
      let month = nowdata.getMonth() + 1
      let date = nowdata.getDate()
      let nowtime = year + '-'
      if (month < 10) {
        nowtime += '0'
      }
      nowtime += month + '-'
      if (date < 10) {
        nowtime += '0'
      }
      nowtime += date

      return nowtime
    },
    onConfirmDate (date) {
      this.userData.birthday = this.formatter(date)
      this.showDatePicker = false
    },
    onCancelDate () {
      this.showDatePicker = false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  width:90%;
  max-width: 640px;
  padding: 4px 8px;
  border-radius: 3px;
  background-image: linear-gradient(#4C69BA, #3B55A0);
  color: #fff;
}
.date-pop {
  left:auto;
  min-width: 320px;
  max-width:640px;
  background-color:#f4f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Oauth.vue